import { withSvgIcon } from './withSvgIcon';

export const CircleArrow = withSvgIcon(
  <path
    d="M5 12C5 8.13401 8.13401 5 12 5C14.105 5 15.9933 5.92844 17.2777 7.40123L14.3306 7.20651L14.1987 9.20216L19.4299 9.5478C19.981 9.58421 20.4573 9.16699 20.4937 8.6159L20.8393 3.38467L18.8437 3.25281L18.6653 5.95239C17.0198 4.14005 14.6432 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C15.7786 21 19.011 18.6717 20.3454 15.3752L18.4915 14.6248C17.4524 17.192 14.9361 19 12 19C8.13401 19 5 15.866 5 12Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
